import { 
  Asset, 
  AssetResponse, 
  AssetsResponse, 
  CreateAssetRequest, 
  UpdateAssetStatusRequest
} from '../../types/asset.types';
import apiService from '../api/api.service';

class AssetService {
  private static instance: AssetService;

  private constructor() {}

  public static getInstance(): AssetService {
    if (!AssetService.instance) {
      AssetService.instance = new AssetService();
    }
    return AssetService.instance;
  }

  /**
   * Yeni zimmet oluşturur
   * @param assetData - Zimmet bilgileri
   * @returns Promise<Asset>
   */
  public async createAsset(assetData: CreateAssetRequest): Promise<Asset> {
    const response = await apiService.post<Asset>('/assets', assetData);
    return response;
  }

    /**
   * Belirli bir kullanıcının zimmetlerini getirir
   * @param userId - Kullanıcı ID'si
   * @returns Promise<Asset[]>
   */
  public async getUserAssets(userId: number): Promise<Asset[]> {
    const response = await apiService.get<Asset[]>(`/assets/user/${userId}`);
    return response;
  }

  /**
   * Tüm zimmetleri getirir (admin için)
   * @returns Promise<Asset[]>
   */
  public async getAllAssets(): Promise<Asset[]> {
    const response = await apiService.get<Asset[]>('/assets');
    return response;
  }

  /**
   * Zimmet durumunu günceller
   * @param assetId - Zimmet ID'si
   * @param statusData - Yeni durum bilgisi
   * @returns Promise<Asset>
   */
  public async updateAssetStatus(assetId: number, statusData: UpdateAssetStatusRequest): Promise<Asset> {
    const response = await apiService.patch<Asset>(`/assets/${assetId}/status`, statusData);
    return response;
  }

  /**
   * Zimmeti siler
   * @param assetId - Zimmet ID'si
   * @returns Promise<void>
   */
  public async deleteAsset(assetId: number): Promise<void> {
    await apiService.delete(`/assets/${assetId}`);
  }

  /**
   * Kullanıcının iade edilmemiş zimmetlerini kontrol eder
   * @param userId - Kullanıcı ID'si
   * @returns Promise<{hasUnreturnedAssets: boolean, assets: Asset[]}>
   */
  public async checkUserUnreturnedAssets(userId: number): Promise<{
    hasUnreturnedAssets: boolean;
    assets: Asset[];
  }> {
    const userAssets = await this.getUserAssets(userId);

    const unreturnedAssets = userAssets.filter(asset => asset.status === 'ASSIGNED');
    
    return {
      hasUnreturnedAssets: unreturnedAssets.length > 0,
      assets: unreturnedAssets
    };
  }
}

export default AssetService.getInstance(); 